// extracted by mini-css-extract-plugin
export default {"Root":"ConfirmDialog_Root__jp5C-","Content":"ConfirmDialog_Content__rN3qw","InfoSection":"ConfirmDialog_InfoSection__63EFy","Text":"ConfirmDialog_Text__kM-I0"};